"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useLifecycles_1 = require("./useLifecycles");

var useLogger = function useLogger(name, props) {
  useLifecycles_1.default(function () {
    return console.log(name + " mounted");
  }, function () {
    return console.log(name + " un-mounted");
  });
  react_1.useEffect(function () {
    console.log(name + " props updated", props);
  });
};

exports.default = useLogger;